export const breakpoints = {
    mobile: 767,
};
